<template>
  <div class="chat-header">
    <div class="flex-between">
      <div class="chat-logo">
        <img src="/images/logo.png" alt="avatar" />
        <div>
          <div class="chat-name">ติดต่อเรา</div>
          <div class="chat-subtitle"></div>
        </div>
      </div>
      <b-button
        size="is-medium"
        class="section-button load-btn"
        @click="loadHistory"
      >
        <i class="fas fa-sync"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatHeader',
  methods: {
    loadHistory() {
      this.$parent.getHistory(true)
    }
  }
}
</script>

<style scoped lang="scss">
.section-button-invert {
  font-size: 0.9rem !important;
  font-weight: bold;
}
.load-btn {
  align-self: flex-end;
  bottom: 12px;
}
.menu-btn {
  line-height: 28px;
}
</style>
